/*
 * ct-product-reviews.js | Cosmetique Totale
 * Breedte gelijk aan de PDP + reacties van de winkel in eigen opmaak:
 * logo links, rechts "Antwoord van <naam>:" en de tekst.
 * Judge.me-eigen kop (incl. ">> antwoordde:") wordt verborgen via .ct-review-reply-source.
 * Stijl: assets/judgeme-custom.css (blok "Reactie van de winkel").
 */
if (!customElements.get('ct-product-reviews')) {
  const CT_REPLY_LABEL = { nl: 'Antwoord van', de: 'Antwort von', en: 'Reply from', fr: 'Réponse de' };

  customElements.define('ct-product-reviews', class extends HTMLElement {
    connectedCallback() {
      const product = document.querySelector('[id^="ProductSection-"][style*="--ctPdpMax"]');
      if (product) this.style.setProperty('--ct-review-width', product.style.getPropertyValue('--ctPdpMax'));
      const lang = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
      this.replyLabel = CT_REPLY_LABEL[lang] || CT_REPLY_LABEL.nl;
      this.decorateReplies();
      this.observer = new MutationObserver(() => this.decorateReplies());
      this.observer.observe(this, { childList: true, subtree: true });
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    decorateReplies() {
      this.querySelectorAll('.jdgm-rev__reply').forEach(reply => {
        const content = reply.querySelector('.jdgm-rev__reply-content');
        if (!content || !content.textContent.trim()) {
          reply.hidden = true;
          return;
        }
        reply.hidden = false;
        if (reply.querySelector(':scope > .ct-review-reply-body')) return;

        const replier = reply.querySelector('.jdgm-rev__replier');
        const name = replier?.textContent.trim() || this.dataset.replyName || 'Cosmetique Totale';

        // Judge.me-kop verbergen; losse tekst (">> antwoordde:") leegmaken
        [...reply.childNodes].forEach(node => {
          if (node === content) return;
          if (node.nodeType === Node.TEXT_NODE) node.textContent = '';
          else if (node.nodeType === Node.ELEMENT_NODE) node.classList.add('ct-review-reply-source');
        });

        if (this.dataset.replyLogo) {
          const image = document.createElement('img');
          image.className = 'ct-review-reply-logo';
          image.src = this.dataset.replyLogo;
          image.alt = '';
          image.width = 48;
          image.height = 48;
          image.loading = 'lazy';
          reply.prepend(image);
        }

        const body = document.createElement('div');
        body.className = 'ct-review-reply-body';
        const title = document.createElement('p');
        title.className = 'ct-review-reply-title';
        title.textContent = `${this.replyLabel} ${name}:`;
        body.append(title, content);
        reply.append(body);
      });
    }
  });
}
